/**
 * Статус обращения в поддержку словами — одинаково в кассе и бекофисе.
 *
 * Статусы в Help (SupportHub) — данные, их правит админ, поэтому Help с
 * контракта v2 присылает подпись (helpdeskStatusLabel). Подписи нет (старый Help
 * или событие ещё не приходило) — переводим известные ключи сами, а незнакомый
 * ключ показываем как есть: лучше «escalated», чем пустое место.
 */
export const SUPPORT_STATUS_LABEL: Record<string, string> = {
  open: 'Открыто',
  new: 'Новое',
  in_progress: 'В работе',
  waiting: 'Ждём вашего ответа',
  pending: 'Ждём вашего ответа',
  resolved: 'Решено',
  closed: 'Закрыто'
}

export interface SupportStatusSource {
  /** Доставка нашей копии в Help: queued | sent. */
  status: string
  helpdeskStatus: string | null
  helpdeskStatusLabel?: string | null
}

export function supportStatusText(t: SupportStatusSource): string {
  if (t.status !== 'sent') return 'Ждёт отправки в поддержку'
  if (t.helpdeskStatusLabel?.trim()) return t.helpdeskStatusLabel.trim()
  if (!t.helpdeskStatus) return 'Принято'
  return SUPPORT_STATUS_LABEL[t.helpdeskStatus] ?? t.helpdeskStatus
}
